import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getLevelItemStyle } from '../patterns/level-item.mjs';
import { styled } from './factory.mjs';

export const LevelItem = /* @__PURE__ */ forwardRef(function LevelItem(props, ref) {
  const [patternProps, restProps] = splitProps(props, [])

const styleProps = getLevelItemStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })